/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SkillAreaModel } from '../../models/skill-area-model';

export interface SaveSkillArea$Params {
      body?: SkillAreaModel
}

export function SaveSkillArea(http: HttpClient, rootUrl: string, params?: SaveSkillArea$Params, context?: HttpContext): Observable<StrictHttpResponse<SkillAreaModel>> {
  const rb = new RequestBuilder(rootUrl, SaveSkillArea.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SkillAreaModel>;
    })
  );
}

SaveSkillArea.PATH = '/api/Supervisor/SaveSkillArea';
